export function skipFilters(filterType) {
    if (typeof filterType === 'undefined') {
        return true;
    }
    return filterType < 1 || filterType > 3;
}
